import { render, staticRenderFns } from "./ShiciGameLayout.vue?vue&type=template&id=24a61aad&scoped=true"
import script from "./ShiciGameLayout.vue?vue&type=script&lang=js"
export * from "./ShiciGameLayout.vue?vue&type=script&lang=js"
import style0 from "./ShiciGameLayout.vue?vue&type=style&index=0&id=24a61aad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a61aad",
  null
  
)

export default component.exports